import styled from "styled-components";
import { FlexMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const Footer = styled.div.withConfig({
    displayName: "styled__Footer",
    componentId: "sc-572d7072-0"
})`
	${FlexMixin({
    align: 'center',
    justify: 'space-between'
})}
	gap: 8px;
`;

//# sourceMappingURL=styled.js.map